import { TransitionState } from './TransitionState';
import { ReturnFocus } from './ReturnFocus';

// FIXME: Move to the class property once the state could be read in PageWrapper.
export const SidePanelWidth = 420;
export const SidePanelInset = 12;

export class SidePanelState {
  readonly transition = new TransitionState<string>();
  readonly focus = new ReturnFocus();

  get isOpen() {
    return this.transition.show;
  }

  get currentPanelId() {
    return this.transition.data;
  }

  close() {
    this.transition.clickClose();
    this.focus.onClose();
  }

  _open(id: string) {
    this.transition.setSync(id);
    this.focus.onOpen();
  }

  init() {
    const disposers = [this.focus.init()];

    return () => {
      disposers.forEach((d) => d());
    };
  }
}
